function updateStitchPayment(disclosure, priceCents) {
  const cents = Number(priceCents);
  const source = disclosure.querySelector('.bnpl-product-widget');
  const available = disclosure.dataset.currencyCode === 'ZAR' && source && Number.isFinite(cents) && cents > 0;
  disclosure.hidden = !available;
  if (!available) return;

  const monthly = Math.round(cents / 6) / 100;
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(monthly);
  disclosure.querySelector('[data-sak-stitch-amount]').textContent = `R ${formatted}/month`;
}

function initStitchDisclosures(root = document) {
  root.querySelectorAll('[data-sak-stitch-disclosure]:not([data-sak-stitch-ready])').forEach((disclosure) => {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const sourceLogo = disclosure.querySelector('.bnpl-product-widget svg');
    const logoHost = disclosure.querySelector('[data-sak-stitch-logo]');
    const summary = disclosure.querySelector('summary');
    let hoverOpened = false;
    disclosure.dataset.sakStitchReady = 'true';

    if (sourceLogo && logoHost) {
      const logo = sourceLogo.cloneNode(true);
      const clip = logo.querySelector('clipPath[id]');
      logo.removeAttribute('style');
      logo.setAttribute('aria-hidden', 'true');
      if (clip) {
        const clipId = `sak-stitch-clip-${disclosure.dataset.sectionId.replace(/[^a-z0-9]/gi, '')}`;
        logo.querySelectorAll(`[clip-path="url(#${clip.id})"]`).forEach((element) => {
          element.setAttribute('clip-path', `url(#${clipId})`);
        });
        clip.id = clipId;
      }
      logoHost.replaceChildren(logo);
    }

    updateStitchPayment(disclosure, disclosure.dataset.initialPriceCents);

    disclosure.addEventListener('pointerenter', (event) => {
      if (canHover.matches && event.pointerType === 'mouse') {
        hoverOpened = true;
        disclosure.open = true;
      }
    });
    disclosure.addEventListener('pointerleave', (event) => {
      if (canHover.matches && event.pointerType === 'mouse') {
        hoverOpened = false;
        disclosure.open = false;
      }
    });
    summary?.addEventListener('click', (event) => {
      // A mouse click after hover has already opened the row must not close it.
      if (hoverOpened && event.detail > 0) event.preventDefault();
    });
    disclosure.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        disclosure.open = false;
        disclosure.querySelector('summary')?.focus();
      }
    });
    disclosure.addEventListener('focusout', (event) => {
      if (!disclosure.contains(event.relatedTarget) && !disclosure.matches(':hover')) disclosure.open = false;
    });
  });
}

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    document.querySelectorAll('[data-sak-stitch-disclosure]').forEach((disclosure) => {
      if (disclosure.dataset.sectionId === data.sectionId) updateStitchPayment(disclosure, data.variant?.price);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initStitchDisclosures(), { once: true });
} else {
  initStitchDisclosures();
}
document.addEventListener('shopify:section:load', (event) => initStitchDisclosures(event.target));
document.addEventListener('product-info:loaded', (event) => initStitchDisclosures(event.target));
